/**
 * Contributor arche detail page. Single-purpose for v1: just the
 * Asset Library section. When the next contributor-management
 * feature lands, we add a tab container alongside it. Placeholder
 * tabs add test surface and make the page feel unfinished, so
 * we ship one clean section instead.
 */

import { useParams, Link } from 'react-router-dom';
import { AssetLibraryManager } from '../components/AssetLibraryManager';

export default function ArcheDetailPage() {
  const { archeId } = useParams<{ archeId: string }>();

  if (!archeId) {
    return (
      <div className="container mx-auto p-6">
        <div className="text-destructive">Missing arche id in URL.</div>
        <Link to="/contributor/dashboard" className="text-sm text-primary hover:underline">
          ← Back to dashboard
        </Link>
      </div>
    );
  }

  return (
    <div className="container mx-auto p-6">
      <div className="mb-4 text-sm text-muted-foreground">
        <Link to="/contributor/dashboard" className="hover:underline">
          ← My arches
        </Link>
      </div>
      <h1 className="text-2xl font-bold">Arche</h1>
      <div className="mb-6 font-mono text-xs text-muted-foreground">{archeId}</div>
      <AssetLibraryManager archeId={archeId} />
    </div>
  );
}
